import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Button, Box, Typography, IconButton, Chip, TextField, InputAdornment, Dialog, DialogTitle, DialogContent, Switch, FormControlLabel, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { UserContext } from './../assets/contexts/userContext';
import PageTitle from '../components/PageTitle';
import StatsCards from './statsCards';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import DashboardNavbar from '../components/dashboard/DashboardNavbar';
import ComplexStatisticsCard from '../components/dashboard/ComplexStatisticsCard';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import TableRowsIcon from '@mui/icons-material/TableRows';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import * as utils from '../assets/js/utils';
import * as endPoints from '../assets/js/endpoints';
import Paper from '@mui/material/Paper';
import ActivityAttendanceChart from './activityAttendanceChart';
import { useNotification } from '../assets/contexts/notificationContext';
import { Helmet } from 'react-helmet';


function AdminDashboard() {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const [appointments, setAppointments] = useState([]);
  const [clients, setClients] =useState([]);
  const { showNotification } = useNotification();



  useEffect(() => {
    const loadAppointments = async () => {
      try {
        const data = await endPoints.getAppointmentsByRole(user.role, user.id);
        const now = new Date();
        const limit = 15 * 24 * 60 * 60 * 1000; // 15 días
        const upcoming = (Array.isArray(data) ? data : [])
          .filter(a => {
            const dt = new Date(`${a.date}T${a.time || '00:00'}`);
            return dt > now && dt - now <= limit;
          })
          .sort(
            (a, b) =>
              new Date(`${a.date}T${a.time || '00:00'}`) -
              new Date(`${b.date}T${b.time || '00:00'}`)
          );      
        setAppointments(upcoming);
      } catch (_err) {
        showNotification('Error cargando citas', 'error');
      }
    };

    if (user.id !== null) loadAppointments();
  }, [user.id, user.role]);



  return (
    <>
      <Helmet>
        <title>Panel del Admin | CES</title>
      </Helmet>
      <DashboardLayout>
      {/* <DashboardNavbar title="Admin" /> */}
      <Box py={3}>
        <PageTitle>Bienvenid@ {`${user.name} ${user.lastName ?? ''}`}</PageTitle>
        <Grid container spacing={3} mt={1} mb={4} sx={{justifyContent:'justify'}}>
           <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard icon={<CalendarMonthRoundedIcon/>} title="Calendario" color="primary" onClick={() => navigate('/pages/calendar')}>
              {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/pages/calendar')}>
                Ver Calendario
              </Button> */}
            </ComplexStatisticsCard>
          </Grid>
           <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard icon={<EventAvailableRoundedIcon/>} title="Actividades" color="primary" onClick={() => navigate('/admin/manageActivities')}>
                {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/admin/manageActivities')}>
                  Ver Actividades
                </Button> */}
            </ComplexStatisticsCard>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard icon={<ArticleRoundedIcon/>} title="Formaciones" color="primary" onClick={() => navigate('/admin/manageFormations')}>
                {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/admin/manageFormations')}>
                  Ver Formaciones
                </Button> */}
            </ComplexStatisticsCard>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard icon={<PeopleAltRoundedIcon/>} title="Usuarios" colors="primary" onClick={() => navigate('/admin/usuarios')}>
              {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/admin/usuarios')}>
                Ver Usuarios
              </Button> */}
            </ComplexStatisticsCard>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard icon={<ArticleRoundedIcon/>} title="Formularios" color="primary" onClick={() => navigate('/admin/manageForms')}>
              {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/admin/manageForms')}>
               Ver Formularios
              </Button> */}
            </ComplexStatisticsCard>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard icon={<ArticleRoundedIcon/>} title="Artículos" color="primary" onClick={() => navigate('/admin/manageArticles')}>
              {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/admin/manageArticles')}>
              Ver Artículos
              </Button> */}
            </ComplexStatisticsCard>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard  icon={<PeopleAltRoundedIcon/>} title="Clientes" color="primary" onClick={() => navigate('/admin/manageClients')}>
              {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/admin/manageClients')}>
              Ver Clientes
              </Button> */}
            </ComplexStatisticsCard>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard  icon={<ArticleRoundedIcon/>} title="Informes" color="primary"  onClick={() => navigate('/admin/manageReports')}>
              {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/admin/manageReports')}>
              Ver Informes
              </Button> */}
            </ComplexStatisticsCard>
          </Grid>
        
          {/* <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard  icon={<ArticleRoundedIcon/>} title="Gestión de Servicios" color="primary">
              <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/admin/manageServices')}>
              Ver Servicios
              </Button>
            </ComplexStatisticsCard>
          </Grid> */}
        </Grid>
       
        <Paper elevation={3} sx={{ p:3, mt:3 }}>
        <Grid item xs={12} md={6} lg={4}>
            <Typography sx={{fontWeight:700}} gutterBottom>
              Próximas citas (15 días)
            </Typography>
            {appointments.length > 0 ? (
              <TableContainer>
                <Table size="small" sx={{ '& td, & th': { borderColor: '#D4D4D4' } }}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{fontWeight:700}}>Cliente</TableCell>
                      <TableCell sx={{fontWeight:700}}>Empleado</TableCell>
                      <TableCell sx={{fontWeight:700}}>Servicio</TableCell>
                      <TableCell sx={{fontWeight:700}}>Fecha</TableCell>
                      <TableCell sx={{fontWeight:700}}>Hora</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {appointments.map(a => (
                      <TableRow key={a.id}>
                        <TableCell sx={{ minWidth: 160 }}>
                          {(a.client_name && a.client_name !== 'null') ? a.client_name : 'Sin cliente'}{' '}
                          {(a.client?.apellidos && a.client.apellidos !== 'null') ? a.client.apellidos : ''}
                        </TableCell>
                        <TableCell>{a.employee_name || a.users?.[0]?.name}</TableCell>
                        <TableCell>{a.service_name || a.service?.name}</TableCell>
                        <TableCell>{a.date}</TableCell>
                        <TableCell>{(a.time || '').substring(0,5)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography>Aún no hay citas concertadas</Typography>
            )}
          </Grid>
           </Paper>
        <StatsCards />
      </Box>
      </DashboardLayout>
    </>
  );
}

export default AdminDashboard;
